import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { filter, map, switchMap, take, tap } from 'rxjs';
import { ConfigService } from 'src/app/shared/services/config.service';
import { UserJobsService } from 'src/app/shared/services/user-jobs.service';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
  selector: 'app-my-jobs',
  templateUrl: './my-jobs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatCard, MatCardContent, MatButton, RouterLink, AsyncPipe]
})
export class MyJobsComponent {
  showNoJobsMessage = false;
  jobsSummary$ = this.getJobsSummary().pipe(
    tap(({ deliveries, workshop }) => {
      this.showNoJobsMessage = !deliveries && !workshop;
    })
  );

  totalJobCount$ = this.jobsSummary$.pipe(
    map(({ deliveries, workshop }) => {
      return deliveries + workshop;
    })
  );

  constructor(
    private userJobsService: UserJobsService,
    private configService: ConfigService
  ) {}

  getJobsSummary() {
    return this.configService.currentUser.pipe(
      filter(Boolean),
      take(1),
      switchMap((user) => this.userJobsService.getJobs(user.id, null, true))
    );
  }
}
